import { defineThemeConfig } from '@core';
import { RouteTransitions, Skins } from '@core/enums';
import logo from '@images/logo.svg?raw';
import { AppContentLayoutNav, ContentWidth, FooterType, NavbarType } from '@layouts/enums';
import { breakpointsVuetify } from '@vueuse/core';
import { VIcon } from 'vuetify/components/VIcon';

export const { themeConfig, layoutConfig } = defineThemeConfig({
  app: {
    title: 'wisePPC',
    logo: h('div', {
      innerHTML: logo,
      style: 'line-height:0; color: rgb(var(--v-global-theme-primary))',
    }),
    contentWidth: ContentWidth.Boxed,
    contentLayoutNav: AppContentLayoutNav.Vertical,
    overlayNavFromBreakpoint: breakpointsVuetify.md + 16,
    enableI18n: true,
    theme: 'light',
    isRtl: false,
    skin: Skins.Default,
    routeTransition: RouteTransitions.Fade,
    iconRenderer: VIcon,
  },
  navbar: {
    type: NavbarType.Sticky,
    navbarBlur: true,
  },
  footer: { type: FooterType.Static },
  verticalNav: {
    isVerticalNavCollapsed: true,
    defaultNavItemIconProps: { icon: 'tabler-circle', size: 10 },
    isVerticalNavSemiDark: false,
  },
  horizontalNav: {
    type: 'sticky',
    transition: 'slide-y-reverse-transition',
  },
  icons: {
    chevronDown: { icon: 'tabler-chevron-down' },
    chevronRight: { icon: 'tabler-chevron-right', size: 18 },
    close: { icon: 'tabler-x' },
    verticalNavPinned: { icon: 'ic-twotone-menu' },
    verticalNavUnPinned: { icon: 'ic-twotone-menu' },
    sectionTitlePlaceholder: { icon: 'tabler-separator' },
  },
});
